import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, Users, MessageSquare, Calendar } from "lucide-react";

interface MetricsData {
  sendings: {
    total: number;
    successful: number;
  };
  properties: {
    total: number;
    available: number;
  };
  owners: {
    total: number;
    active: number;
  };
  schedules: {
    total: number;
    pending: number;
  };
}

interface MetricsCardsProps {
  data: MetricsData;
}

export function MetricsCards({ data }: MetricsCardsProps) {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
      <Card className="group hover:shadow-md transition-all duration-200">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-gray-600">
            Mensagens
          </CardTitle>
          <MessageSquare className="h-5 w-5 text-primary group-hover:scale-110 transition-transform" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{data.sendings.total}</div>
          <p className="text-sm text-gray-500 mt-2">
            {data.sendings.successful} enviadas com sucesso
          </p>
        </CardContent>
      </Card>

      <Card className="group hover:shadow-md transition-all duration-200">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-gray-600">
            Imóveis
          </CardTitle>
          <Building2 className="h-5 w-5 text-primary group-hover:scale-110 transition-transform" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{data.properties.total}</div>
          <p className="text-sm text-gray-500 mt-2">
            {data.properties.available} disponíveis
          </p>
        </CardContent>
      </Card>

      <Card className="group hover:shadow-md transition-all duration-200">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-gray-600">
            Proprietários
          </CardTitle>
          <Users className="h-5 w-5 text-primary group-hover:scale-110 transition-transform" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{data.owners.total}</div>
          <p className="text-sm text-gray-500 mt-2">
            {data.owners.active} ativos
          </p>
        </CardContent>
      </Card>

      <Card className="group hover:shadow-md transition-all duration-200">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-gray-600">
            Agendamentos
          </CardTitle>
          <Calendar className="h-5 w-5 text-primary group-hover:scale-110 transition-transform" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{data.schedules.total}</div>
          <p className="text-sm text-gray-500 mt-2">
            {data.schedules.pending} pendentes
          </p>
        </CardContent>
      </Card>
    </div>
  );
}